import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Skeleton from "@mui/material/Skeleton";
import Buttons from "../Buttons/Buttons";

const SKELETON_ROW_COUNT = 5;

const TableStatusRow = ({
  colSpan,
  loading,
  error,
  onRetry,
  emptyMessage = "No results found",
}) => {
  if (loading) {
    return (
      <>
        {Array.from({ length: SKELETON_ROW_COUNT }).map((_, rowIndex) => (
          <TableRow key={rowIndex}>
            {Array.from({ length: colSpan }).map((_, cellIndex) => (
              <TableCell key={cellIndex}>
                <Skeleton variant="text" animation="wave" />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </>
    );
  }

  let content = emptyMessage;

  if (error) {
    content = (
      <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
        {error}
        {onRetry && (
          <Buttons text="Retry" type="button" variant="smallsecondary" onClick={onRetry} />
        )}
      </span>
    );
  }

  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center">
        {content}
      </TableCell>
    </TableRow>
  );
};

export default TableStatusRow;
